import React, { useContext } from "react"
import { AuthCheck } from "./AuthCheck"
import { AuthContext, AuthStatus } from "components/authentication/context/authContext"
import SecurityWrapperRoutes from "components/authorization/SecurityWrapperRoutes"
import { Navigate, Route, Routes, useLocation } from "react-router"
import ErrorTemplateFoundPage from "../ErrorTemplatePage"
import intl from 'components/i18n/ReactIntlWrapper';
import Spinner from "components/Spinner"
import { PageLogin } from "components/PageLogin"
import PublicSigningPage from "components/PublicSigning/PublicSigningPage"

const RedirectToLogin = () => {
    const location = useLocation();
    if (location.pathname !== '/login') {
        sessionStorage.setItem('returnUrl', location.pathname + location.search);
    }
    return <Navigate to="/login" />;
};

export default function BerpRoutes() {
    const { authStatus } = useContext(AuthContext);
    return (<>
        {/* Public routes — no authentication required */}
        <Routes>
            <Route path="/sign/:token" element={<PublicSigningPage />} />
        </Routes>

        <AuthCheck status={AuthStatus.SignedIn}>
            <SecurityWrapperRoutes />
        </AuthCheck>
        <AuthCheck status={AuthStatus.SignedOut}>
            <Routes>
                <Route path="/login" element={<PageLogin />} />
                <Route path="/verify" element={<Spinner />} />
                <Route path="/sign/*" element={null} />
                <Route path="*" element={authStatus === AuthStatus.SignedOut ? <RedirectToLogin /> : <ErrorTemplateFoundPage statusCode={404} title={intl.get('notFoundPage.title')} />} />
            </Routes>
        </AuthCheck>
        </>
    )
}
